// extracted by mini-css-extract-plugin
export var dropdownToggle = "DropdownWallet_dropdownToggle__BpU9a";
export var overlay = "DropdownWallet_overlay__41pEE";
export var dropdownMenu = "DropdownWallet_dropdownMenu__iQwCe";
export var blockBalance = "DropdownWallet_blockBalance__kg+2d";
export var toggleInner = "DropdownWallet_toggleInner__b2P2Z";
export var rotate = "DropdownWallet_rotate__QEne6";
export var dotty = "DropdownWallet_dotty__GfUMr";